import { render, staticRenderFns } from "./CalidadDistribucionTab.vue?vue&type=template&id=565f6f94&"
import script from "./CalidadDistribucionTab.vue?vue&type=script&lang=js&"
export * from "./CalidadDistribucionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports